module.exports = __webpack_public_path__ + "static/img/intelligent-control-system1.6f2a4c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/intelligent-control-system1.jpg
// module id = CBtJ
// module chunks = 0